module.exports = __webpack_public_path__ + "static/media/import_commande_exemple.2e5da3a5.xlsx";